import React, { useMemo } from 'react'
import Avatar from '@components/common/avatar'
import AvatarUpload from '@components/student-dashboard/gamification/avatar-upload'
import { useProfileContext } from '@contexts/profile'
import classNames from 'classnames'
import Share from '@components/profile/student/share'
import CoverBanner from '@components/profile/student/cover-banner'

type Props = {
  isEditable?: boolean
}

const StudentDetails = ({ isEditable = false }: Props) => {
  const { profileDetails } = useProfileContext()
  const user = useMemo(() => profileDetails, [profileDetails])
  const student = useMemo(() => profileDetails?.student, [profileDetails])

  return (
    <div className="bg-white flex flex-col rounded-lg shadow-sm">
      {student?.userId && <CoverBanner userId={student.userId} />}
      <div className="flex flex-col lg:flex-row">
        <div
          className={classNames(
            'flex items-center justify-center relative lg:w-1/6',
            { 'mb-10': user?.avatar || !isEditable }
          )}
        >
          <div
            className={classNames(
              'rounded-full p-2 lg:p-3 lg:top-0 lg:-mt-10 lg:right-0',
              {
                absolute: user?.avatar || !isEditable,
                'mt-3 lg:mt-0': isEditable && !user?.avatar,
              }
            )}
          >
            {isEditable && <AvatarUpload isCustomAvatar={!!user?.avatar} />}
            {!isEditable && (
              <Avatar image={user?.avatar} size="big" isNotCurrentUser />
            )}
          </div>
        </div>
        <div className="flex flex-col space-y-3 p-5 leading-tight text-grey w-full">
          <div className="flex justify-between">
            <h1 className="text-2xl lg:text-3xl font-600 break-all">
              {user?.name}
            </h1>
            <div className="hidden lg:block">
              <Share />
            </div>
          </div>
          <h2 className="text-xl font-600">
            {student?.grade}{' '}
            {user?.isPaidUser && (
              <>
                | Points: {student?.points} | Rank: {student?.rank}{' '}
              </>
            )}
          </h2>{' '}
          {user?.bio && <p className="break-all">{user?.bio}</p>}
          {user?.hobbies && (
            <p className="break-all">
              <span className="font-600">Hobby:</span> {user?.hobbies}
            </p>
          )}
          <div className="lg:hidden">
            <Share />
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(StudentDetails)
